var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49422 15.8632C9.33084 15.8719 9.19971 16.0048 9.19971 16.1684V22.325C9.19971 22.4907 9.33402 22.625 9.49971 22.625H11.8997C12.0654 22.625 12.1997 22.4907 12.1997 22.325V15.7011C12.1997 15.4873 11.9823 15.3417 11.7806 15.4124C11.0591 15.6654 10.2917 15.8209 9.49422 15.8632Z",
    fill: "#646D7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3115 13.9797C14.2414 14.0379 14.1997 14.1238 14.1997 14.215V22.325C14.1997 22.4907 14.334 22.625 14.4997 22.625H16.8997C17.0654 22.625 17.1997 22.4907 17.1997 22.325V9.7058C17.1997 9.66118 17.1635 9.625 17.1189 9.625C17.0818 9.625 17.0495 9.65034 17.0402 9.68627C16.601 11.394 15.6289 12.8878 14.3115 13.9797Z",
    fill: "#646D7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1997 22.325C22.1997 22.4907 22.0654 22.625 21.8997 22.625H19.4997C19.334 22.625 19.1997 22.4907 19.1997 22.325V5.925C19.1997 5.75931 19.334 5.625 19.4997 5.625H21.8997C22.0654 5.625 22.1997 5.75931 22.1997 5.925V22.325Z",
    fill: "#646D7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19971 22.325C7.19971 22.4907 7.06539 22.625 6.89971 22.625H4.49971C4.33402 22.625 4.19971 22.4907 4.19971 22.325V17.925C4.19971 17.7593 4.33402 17.625 4.49971 17.625H6.89971C7.06539 17.625 7.19971 17.7593 7.19971 17.925V22.325Z",
    fill: "#646D7B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7998 7.625C2.7998 4.17296 5.59776 1.375 9.0498 1.375C12.5018 1.375 15.2998 4.17296 15.2998 7.625C15.2998 11.077 12.5018 13.875 9.0498 13.875C5.59776 13.875 2.7998 11.077 2.7998 7.625ZM9.0498 3.075C6.53665 3.075 4.4998 5.11184 4.4998 7.625C4.4998 10.1382 6.53665 12.175 9.0498 12.175C11.563 12.175 13.5998 10.1382 13.5998 7.625C13.5998 5.11184 11.563 3.075 9.0498 3.075ZM8.1998 4.725C8.1998 4.25556 8.58036 3.875 9.0498 3.875C9.51925 3.875 9.89981 4.25556 9.89981 4.725V6.475C9.89981 6.64069 10.0341 6.775 10.1998 6.775H11.0498C11.5192 6.775 11.8998 7.15556 11.8998 7.625C11.8998 8.09444 11.5192 8.475 11.0498 8.475H9.0498C8.58036 8.475 8.1998 8.09444 8.1998 7.625V4.725Z",
    fill: "#646D7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphTime);
export default __webpack_public_path__ + "static/media/graph-time.3e9e51a4ab8e3495b033a5550626c4a8.svg";
export { ForwardRef as ReactComponent };